import { useState } from "react";

export function useMenuCodigoDetran() {
  const [abertoCodigoDetran, setAbertoCodigoDetran] = useState<boolean>(false);

  return {
    abertoCodigoDetran,
    setAbertoCodigoDetran,
  };
}
